import { getAssetsUrl } from "@/constants/url";

interface PreloadProps {
  hrefs: string[];
  as: "image" | "script" | "style" | "font" | "document";
}

export function Preload({ hrefs, as }: PreloadProps) {
  return (
    <>
      {hrefs.map((href) => (
        <link key={href} rel="preload" href={href} as={as} />
      ))}
    </>
  );
}

Preload.Image = function Image({ fileNames }: { fileNames: string[] }) {
  return <Preload hrefs={fileNames.map((name) => getAssetsUrl(name))} as="image" />;
};
